/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module CollectionsModule
 * @preferred
 */

import { NgModule } from '@angular/core';
import { createNgDependencyProviders } from 'ng/modules/data-model/utils/inject-ng-dependencies.utils';

import {
    AlbServicesSiteCollection,
    AlertCollection,
    AlertSyslogConfigCollection,
    AvailabilityZoneCollection,
    ControllerBannerAlertCollection,
    ControllerFaultCollection,
    ControllerSiteCollection,
    CSRFPolicyCollection,
    FileObjectCollection,
    GSLBCollection,
    GSLBInventoryCollection,
    GSLBVSCollection,
    LicensePoolCollection,
    PoolCollection,
    PoolGroupCollection,
    PoolGroupDeploymentPolicyCollection,
    ReportCollection,
    ServiceEngineCollection,
    SystemReportsCollection,
    TechSupportCollection,
    TechSupportProfileCollection,
    TenantSettingsCollection,
    TenantUsageCollection,
    TrustedHostProfileCollection,
    UpgradeProfileCollection,
    VirtualServiceCollection,
    WafCrsCollection,
} from './factories';

const providers = createNgDependencyProviders([
    AlbServicesSiteCollection,
    AlertCollection,
    AlertSyslogConfigCollection,
    AvailabilityZoneCollection,
    ControllerBannerAlertCollection,
    ControllerFaultCollection,
    ControllerSiteCollection,
    CSRFPolicyCollection,
    FileObjectCollection,
    GSLBCollection,
    GSLBInventoryCollection,
    GSLBVSCollection,
    LicensePoolCollection,
    PoolCollection,
    PoolGroupCollection,
    PoolGroupDeploymentPolicyCollection,
    ReportCollection,
    ServiceEngineCollection,
    SystemReportsCollection,
    TechSupportCollection,
    TechSupportProfileCollection,
    TenantSettingsCollection,
    TenantUsageCollection,
    TrustedHostProfileCollection,
    UpgradeProfileCollection,
    VirtualServiceCollection,
    WafCrsCollection,
]);

/**
 * @description
 * Module for registering Collection files. Collections can be imported by the 'collections/*' path
 * which points to 'collections/factories'. This module should contain providers only.
 * @author alextsg
 */
@NgModule({ providers })
export class CollectionsModule { }
